import {css, StyleSheet} from 'aphrodite';
import classNames from 'classnames';
import React from 'react';

import SequenceAlignmentTabOptionsView from 'analyses/alignment/SequenceAlignmentTabOptionsView';
import BufferOptionsItem from 'buffers/BufferOptionsItem';
import {renderToDOM} from 'redux-stores/ReduxDOMRender';
import DisplayOptions from 'settings/visibility-options/DisplayOptions';
import {VisibilityOptions} from 'settings/visibility-options/VisibilityOptions';
import getTestProps from 'test/lib/cypress/getTestProps';
import Button, {ButtonSize, ButtonStyle} from 'ui-library/buttons/Button';
import ButtonGroup from 'ui-library/buttons/ButtonGroup';

interface SimplifiedAlignmentTabMenuProps {
  goToMismatch: (direction: 'next' | 'previous') => void;
  loaded: boolean;
  visibilityOptions: VisibilityOptions;
}

function SimplifiedAlignmentTabMenu({
  goToMismatch,
  loaded,
  visibilityOptions,
}: SimplifiedAlignmentTabMenuProps): JSX.Element {
  return (
    <div
      className={classNames('buffer-options-container', 'sequence-alignment-menu', css(styles.container))}
      {...getTestProps({component: 'AlignmentTabMenu', element: 'root'})}
    >
      <BufferOptionsItem className={css(styles.expander)} />
      <BufferOptionsItem>
        <span className={css(styles.mismatchLabel)}>Find Mismatches</span>
        <Button
          buttonStyle={ButtonStyle.TERTIARY_GRAY}
          size={ButtonSize.MINI}
          className="alignment-previous-mismatch"
          icon="chevron-left"
          onClick={() => {
            goToMismatch('previous');
          }}
          disabled={!loaded}
        />
        <span className={css(styles.mismatchSpacer)} />
        <Button
          buttonStyle={ButtonStyle.TERTIARY_GRAY}
          size={ButtonSize.MINI}
          className="alignment-next-mismatch"
          icon="chevron"
          onClick={() => {
            goToMismatch('next');
          }}
          disabled={!loaded}
        />
      </BufferOptionsItem>
      <BufferOptionsItem className="u-vertical-center-items">
        <ButtonGroup>
          <DisplayOptions dropLeft={true} options={visibilityOptions} />
        </ButtonGroup>
      </BufferOptionsItem>
    </div>
  );
}

const styles = StyleSheet.create({
  mismatchLabel: {
    marginRight: '5px',
  },
  mismatchSpacer: {
    marginRight: '2px',
  },
  expander: {
    flex: 1,
  },
  container: {
    height: '38px',
  },
});

export class SimplifiedSequenceAlignmentTabOptionsView extends SequenceAlignmentTabOptionsView {
  render(): this {
    renderToDOM(<SimplifiedAlignmentTabMenu {...this.getProps()} />, this.el);
    return this;
  }
}
